import React, { useEffect, useState } from 'react';
import { Clock3Icon, EyeIcon, SparklesIcon } from 'lucide-react';
interface OfferTime {
  day: string;
  hours: string;
  minutes: string;
  seconds: string;
}
function getOfferTime(): OfferTime {
  const now = new Date();
  const tomorrow = new Date(now);
  tomorrow.setHours(24, 0, 0, 0);
  const remaining = Math.max(0, tomorrow.getTime() - now.getTime());
  const totalSeconds = Math.floor(remaining / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return {
    day: new Intl.DateTimeFormat('it-IT', {
      weekday: 'long'
    }).format(now).toUpperCase(),
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0')
  };
}
interface TimeUnitProps {
  value: string;
  label: string;
}
function TimeUnit({
  value,
  label
}: TimeUnitProps) {
  return <div className="flex min-w-[38px] flex-col items-center" data-id="element-221" data-mp="2epiw791mdg22">
      <span className="font-serif-display text-3xl font-bold leading-none text-white sm:text-4xl" data-id="element-222" data-mp="j5iek4gyj7gf">
        {value}
      </span>
      <span className="mt-1 text-[10px] font-semibold tracking-[0.13em] text-white/55" data-id="element-223" data-mp="e9uqjse7okci">{label}</span>
    </div>;
}
export function TodayOfferCard() {
  const [offerTime, setOfferTime] = useState<OfferTime>(getOfferTime);
  useEffect(() => {
    const timer = window.setInterval(() => setOfferTime(getOfferTime()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <aside aria-label="Tempo rimanente per l’offerta di oggi" className="mt-4 overflow-hidden rounded-2xl border border-cobalt/80 bg-ink px-4 py-4 text-white shadow-[0_14px_30px_-18px_rgba(31,36,48,0.8)] ring-1 ring-cobalt/15 sm:px-5 sm:py-4" data-id="element-224" data-mp="3rohky0rqrou9">
      <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:justify-between sm:gap-5 sm:text-left" data-id="element-225" data-mp="3cwz0nqrun853">
        <div className="min-w-0" data-id="element-226" data-mp="37y4gake8hbiv">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-cobalt/50 bg-cobalt/15 px-2.5 py-1 text-[11px] font-bold tracking-[0.12em] text-white" data-id="element-227" data-mp="37wt9sctelpo2">
            <SparklesIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-228" data-mp="1gsrji6j5kvgq" />
            OFFERTA DI OGGI
          </span>
          <p className="mt-2 text-xs font-medium uppercase tracking-[0.18em] text-white/65" data-id="element-229" data-mp="1lnoo919egint">
            {offerTime.day}
          </p>
          <p className="mt-1 text-sm leading-snug text-white/85" data-id="element-230" data-mp="sx6pudjmf5gq">
            L’offerta termina a mezzanotte. Non passare un’altra serata a ricostruire da zero una
            lezione che potrebbe essere già pronta.
          </p>
        </div>

        <div className="flex shrink-0 items-center gap-3" role="timer" aria-live="polite" data-id="element-231" data-mp="12tjdouship3k">
          <Clock3Icon className="hidden h-5 w-5 text-cobalt sm:block" aria-hidden="true" data-id="element-232" data-mp="16xzj6uy6rui9" />
          <TimeUnit value={offerTime.hours} label="ORE" data-id="element-233" data-mp="2e985bzgoocap" />
          <span className="pb-4 font-serif-display text-2xl font-bold text-cobalt" aria-hidden="true" data-id="element-234" data-mp="2ibbgso3crgvz">
            :
          </span>
          <TimeUnit value={offerTime.minutes} label="MIN" data-id="element-235" data-mp="6my89ae6yk8m" />
          <span className="pb-4 font-serif-display text-2xl font-bold text-cobalt" aria-hidden="true" data-id="element-236" data-mp="2mwgpu267772">
            :
          </span>
          <TimeUnit value={offerTime.seconds} label="SEC" data-id="element-237" data-mp="3u0adwsp44axn" />
        </div>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2 border-t border-white/10 pt-3 text-center text-xs text-white/65 sm:justify-start" data-id="element-238" data-mp="3p30npatwfv8r">
        <EyeIcon className="h-3.5 w-3.5 shrink-0 text-cobalt" aria-hidden="true" data-id="element-239" data-mp="3k11li49wb4de" />
        <span data-id="element-240" data-mp="3f2i0c634lwm3">Accedi al prezzo di oggi prima che il tempo scada.</span>
      </div>
    </aside>;
}